module.exports = __webpack_public_path__ + "img/logo-light-text.fb54e365.png";